module.exports = "<div style=\"text-align:center\">\n\n  <h2>Er du ikke helt tosset med matematik</h2>\n\n  <p>Men det kan du blive!</p> \n  \n  <p>Her kan du øve dig - bare 5 minutter om dagen - og så er det næsten sjovt :-)</p>\n\n  <app-card-template [navlinks]=navLinks></app-card-template >\n  \n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/menu/menu.component.html
// module id = ../../../../../src/app/menu/menu.component.html
// module chunks = main